module.exports = __webpack_public_path__ + "img/icon_close.06a12446.svg";